import { hydrateRenderedComponents } from "@streeteasy/render-service/client";

import {
  AccountTools,
  AccountToolsDropdown,
  Advertise,
  AgentToolsDropdown,
  BlogMainNavDropdown,
  BuildingsMainNavDropdown,
  BuyMainNavDropdown,
  ExpertToolsDropdown,
  IndustryHubMainNavDropdown,
  MobileWeb,
  MyActivity,
  OwnerTools,
  PropertyManager,
  RentMainNavDropdown,
  ResourcesMainNavDropdown,
  Search,
  SellMainNavLink
} from "../src/features/header";

hydrateRenderedComponents("reactHeader", {
  accountTools: AccountTools,
  accountToolsAdvertise: Advertise,
  propertyManagerLink: PropertyManager,
  accountToolsDropdown: AccountToolsDropdown,
  agentToolsDropdown: AgentToolsDropdown,
  expertToolsDropdown: ExpertToolsDropdown,
  myActivity: MyActivity,
  ownerTools: OwnerTools,
  rentMainNavDropdown: RentMainNavDropdown,
  buyMainNavDropdown: BuyMainNavDropdown,
  blogMainNavDropdown: BlogMainNavDropdown,
  buildingsMainNavDropdown: BuildingsMainNavDropdown,
  industryHubMainNavDropdown: IndustryHubMainNavDropdown,
  resourcesMainNavDropdown: ResourcesMainNavDropdown,
  Search,
  mobileWeb: MobileWeb,
  sellMainNavLink: SellMainNavLink
});
